var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import AppLayout from '@/Layouts/AppLayout';
import { usePage } from '@inertiajs/react';
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { Button } from "@/components/ui/button";
import { Form, FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage, } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue, } from "@/components/ui/select";
import _ from 'lodash';
import { router } from '@inertiajs/react';
import { useRoute } from 'ziggy-js';
import { Ziggy } from '@/ziggy.js';
import FieldInfo from "@/Jetstream/FieldInfo";
import Breadcrumb from "@/Jetstream/Breadcrumb";
function classNames() {
    var classes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classes[_i] = arguments[_i];
    }
    return classes.filter(Boolean).join(' ');
}
export default function Create(_a) {
    var team = _a.team, branches = _a.branches, calendar = _a.calendar;
    var route = useRoute(Ziggy);
    var flash = usePage().props.flash;
    var _b = useState(true), open = _b[0], setOpen = _b[1];
    var branchesIndex = _.keyBy(branches, 'id');
    var vetIndex = _.keyBy(_.flatMap(branches, 'vets'), 'id');
    var formSchema = z.object({
        name: z.string().min(2, {
            message: "Name must be at least 2 characters.",
        }),
        branch_id: z.any().nullable(),
        vet_id: z.any().nullable(),
    });
    var form = useForm({
        resolver: zodResolver(formSchema),
        defaultValues: {
            name: calendar.name,
            branch_id: (calendar.branch_id) || null,
            vet_id: (calendar.vet_id) || null,
        },
    });
    function onSubmit(values) {
        //console.log(values)
        var method = calendar.id ? 'put' : 'post';
        var url = calendar.id ? route('team.calendar.update', { team: team, calendar: calendar }) : route('team.calendar.store', { team: team });
        router[method](url, values);
    }
    useEffect(function () {
    });
    return (_jsx(AppLayout, __assign({ title: "Calendars", pageTitle: "Calendars", breadCrumb: _jsx(Breadcrumb, { team: team, calendar: calendar }) }, { children: _jsx(Form, __assign({}, form, { children: _jsxs("form", __assign({ onSubmit: form.handleSubmit(onSubmit), className: "space-y-8" }, { children: [_jsx(FormField, { control: form.control, name: "branch_id", render: function (_a) {
                            var field = _a.field;
                            return (_jsxs(FormItem, __assign({ onChange: function (e) {
                                    if (!form.getValues('name') && form.getValues('branch_id')) {
                                        form.setValue('name', branchesIndex[form.getValues('branch_id')].name);
                                    }
                                } }, { children: [_jsx(FormLabel, { children: "Branch" }), _jsxs(Select, __assign({ name: "branch-select", onValueChange: field.onChange, value: calendar.branch_id }, { children: [_jsx(FormControl, { children: _jsx(SelectTrigger, __assign({ id: "branch-select-trigger" }, { children: _jsx(SelectValue, __assign({ placeholder: "Select a branch for this calendar..." }, { children: (field === null || field === void 0 ? void 0 : field.value) && _jsx("span", { children: branchesIndex[field.value].name }) })) })) }), _jsx(SelectContent, { children: branches.map(function (branch) { return (_jsx(SelectItem, __assign({ value: branch.id }, { children: branch.name }), branch.id)); }) })] })), _jsx(FormDescription, {}), _jsx(FormMessage, {})] })));
                        } }), _jsx(FormField, { control: form.control, name: "vet_id", defaultValue: calendar.vet_id, render: function (_a) {
                            var _b;
                            var field = _a.field;
                            return (_jsxs(FormItem, __assign({ onChange: function (e) {
                                    if (form.getValues('name') === branchesIndex[form.getValues('branch_id')].name) {
                                        form.setValue('name', vetIndex[form.getValues('vet_id')].name + " at " + branchesIndex[form.getValues('branch_id')].name);
                                    }
                                } }, { children: [_jsx(FormLabel, { children: "Vet (optional)" }), !form.getValues("branch_id") && _jsx(FieldInfo, { text: "Select a branch..." }), form.getValues("branch_id") && _jsxs(Select, __assign({ name: "vet-select", onValueChange: field.onChange, value: calendar.vet_id }, { children: [_jsx(FormControl, { children: _jsx(SelectTrigger, __assign({ id: "vet-select-trigger" }, { children: _jsx(SelectValue, __assign({ placeholder: "Select a vet for this calendar..." }, { children: (field === null || field === void 0 ? void 0 : field.value) && _jsx("span", { children: (_b = vetIndex[field.value]) === null || _b === void 0 ? void 0 : _b.name }) })) })) }), _jsx(SelectContent, { children: branchesIndex[form.getValues('branch_id')].vets.map(function (vet) { return (_jsx(SelectItem, __assign({ value: vet.id }, { children: vet.name }), vet.id)); }) })] })), _jsx(FormDescription, {}), _jsx(FormMessage, {})] })));
                        } }), _jsx(FormField, { control: form.control, name: "name", render: function (_a) {
                            var field = _a.field;
                            return (_jsxs(FormItem, { children: [_jsx(FormLabel, { children: "Name" }), _jsx(FormControl, { children: _jsx(Input, __assign({ placeholder: "Name..." }, field)) }), _jsx(FormDescription, { children: "Descriptive name for this calendar. This could be a branch name." }), _jsx(FormMessage, {})] }));
                        } }), _jsx(Button, __assign({ type: "submit" }, { children: "Submit" }))] })) })) })));
}
